module.exports = __webpack_public_path__ + "img/CNBV.ce920769.svg";